import listCacheClear from './_listCacheClear';
import listCacheDelete from './_listCacheDelete';
import listCacheGet from './_listCacheGet';
import listCacheHas from './_listCacheHas';
import listCacheSet from './_listCacheSet';

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

export default ListCache;



//////////////////
// WEBPACK FOOTER
// ../ckeditor5-utils/src/lib/lodash/_ListCache.js
// module id = null
// module chunks = 